import React, { type FunctionComponent, useState } from 'react'
import { hasEditUserPermission } from '../../../../services/permission.service'
import { UpdateEmailDialog } from '../dialogs/UpdateEmailDialog'
import { Button } from '@tomra/design-system-react/button'

type Props = {
  userInfo: UserInfoType
}

export const UserEmail: FunctionComponent<Props> = ({ userInfo }) => {
  const { id, email } = userInfo

  const [showEmailUpdateDialog, setShowEmailUpdateDialog] = useState(false)

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 items-end gap-4">
      <dl className="col-span-2">
        <dt id="email" className="text-gray-600">
          Email
        </dt>
        <dd className="break-all" aria-labelledby="email">
          {email}
        </dd>
      </dl>

      {hasEditUserPermission() && (
        <>
          <Button className="px-3 py-1 text-xs" onClick={() => setShowEmailUpdateDialog(true)}>
            Update
          </Button>

          {showEmailUpdateDialog && (
            <UpdateEmailDialog
              userId={id}
              onClose={() => {
                setShowEmailUpdateDialog(false)
              }}
            />
          )}
        </>
      )}
    </div>
  )
}
